import { createTheme } from '@mui/material';
import { createSlice } from '@reduxjs/toolkit';
import { Dispatch } from 'redux';
import { Mode } from '../models/sdk';
import SDK from '../sdk/sdk';
import { theme_factory } from '../theme/theme';

// Slice
const authenticatedInitialValue: boolean = (localStorage.getItem('avc-token') && localStorage.getItem('avc-token')?.startsWith('Bearer')) && localStorage.getItem('avc-user_details') && localStorage.getItem('avc-business_id') ? true : false;

const slice = createSlice({
  name: 'sdk',
  initialState: {
    currentRoute: { path: '/', params: {} as any },
    previousRoute: { path: '', params: {} as any },
    mode: '' as Mode,
    routesStack: [] as any[],
    sdk: null as SDK | null,
    authenticated: authenticatedInitialValue,
    theme: theme_factory(),
  },
  reducers: {
    currentRouteChanged: (state, action) => {
      const newRoute = { path: action.payload.path, params: action.payload.params };
      state.currentRoute = newRoute;
      state.routesStack.push(newRoute);
      state.previousRoute = newRoute;   //  not changed by backNavigation
      if (action.payload.path === '/login') {
        state.authenticated = false;
      }
      console.log('currentRouteChanged', state.currentRoute);
    },
    backNavigation: (state) => {
      state.routesStack.pop();
      if (!state.routesStack.length) return;
      
      state.currentRoute = state.routesStack[state.routesStack.length - 1];
      console.log('navigateBack', state.currentRoute.path);
    },
    modeChanged: (state, action) => {
      if (!state.mode) {
        state.mode = action.payload.mode;
      }
    },
    initialize: (state, action) => {
      if (!action.payload.sdk || state.sdk) return;
      state.sdk = action.payload.sdk;
    },
    paramsChanged: (state, action) => {
      const { key, value } = action.payload;
      state.currentRoute.params[key] = value;
      if (state.routesStack.length > 0) state.routesStack[state.routesStack.length - 1].params[key] = value;
    },
    authenticatedChanged: (state, action) => {
      state.authenticated = action.payload;
    },
    themeChanged: (state, action) => {
      state.theme = createTheme(action.payload) as any;
    },
  },
});

export default slice.reducer;

// Actions
const { currentRouteChanged, backNavigation, modeChanged, initialize, paramsChanged, authenticatedChanged, themeChanged } = slice.actions;

export const setCurrentRoute = (path: string, params: any = {}): any => (dispatch: Dispatch): void => {
  dispatch(currentRouteChanged({ path, params }));
}

export const navigateBack = (): any => (dispatch: Dispatch): void => {
  dispatch(backNavigation());
}

export const setMode = (mode: string): any => (dispatch: Dispatch): void => {
  dispatch(modeChanged({ mode }));
}

export const init = (sdk: SDK): any => (dispatch: Dispatch): void => {
  dispatch(initialize({ sdk }));
}

export const setParams = (key: string, value: any): any => (dispatch: Dispatch): void => {
  dispatch(paramsChanged({ key, value }));
}

export const setAuthenticated = (value: boolean): any => (dispatch: Dispatch): void => {
  dispatch(authenticatedChanged(value));
}

export const setTheme = (new_theme: any): any => (dispatch: Dispatch): void => {
  dispatch(themeChanged(new_theme));
}